import {DragDropModule} from '@angular/cdk/drag-drop';
import {PortalModule} from '@angular/cdk/portal';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {TranslateModule} from '@ngx-translate/core';
import {
  ChipsSelectComponent,
  ContentCardComponent,
  ContentLoaderComponent,
  DatetimePickerComponent,
  GridModule,
  IconButtonComponent,
  PrimaryButtonComponent,
  Q9ContextMenuComponent,
  SecondaryButtonComponent,
  SelectModule,
  TagsComboboxModule,
  TagsSelectComponent,
  TextFieldComponent,
  TextareaFieldComponent,
  ToolbarModule,
  UserInfoComponent
} from '@q9elements/ui-kit/components';
import {DpDatePickerModule} from 'ng2-date-picker';

import {SharedModule} from '../../../shared/shared.module';
// tslint:disable-next-line:max-line-length
import {NodePathModule} from '../node-path/node-path.module';
import {AddFiltersViewComponent} from './components/add-filters-view/add-filters-view.component';
import {MiniNodeSearchComponent} from './components/add-filters-view/components/edit-filter-form/components/mini-node-search/mini-node-search.component';
import {UserSearchComponent} from './components/add-filters-view/components/edit-filter-form/components/user-search/user-search.component';
import {EditFilterFormComponent} from './components/add-filters-view/components/edit-filter-form/edit-filter-form.component';
import {FilterItemComponent} from './components/add-filters-view/components/filter-item/filter-item.component';
import {FormatOperatorPipe} from './components/add-filters-view/pipes/format-operator.pipe';
import {FormatValuePipe} from './components/add-filters-view/pipes/format-value.pipe';
import {SubtypeConverterPipe} from './components/add-filters-view/pipes/subtype-converter.pipe';
import {ConfigGenerateService} from './components/add-filters-view/services/config-generate.service';
import {ItemsSelectorModule} from './components/items-selector/items-selector.module';
import {RmeBaseGridFilterComponent} from './components/rme-base-grid-filter/rme-base-grid-filter.component';
import {SelectColumnsViewComponent} from './components/select-columns-view/select-columns-view.component';
import {MetadataItemsComponent} from './components/select-metadata-view/components/metadata-items/metadata-items.component';
import {SelectMetadataViewComponent} from './components/select-metadata-view/select-metadata-view.component';
import {CustomMetadataViewComponent} from './custom-metadata-view.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatInputModule,
    TranslateModule,
    MatDividerModule,
    MatChipsModule,
    DragDropModule,
    MatCardModule,
    PortalModule,
    DpDatePickerModule,
    ContentLoaderComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    SelectModule,
    TextFieldComponent,
    TextareaFieldComponent,
    IconButtonComponent,
    ContentCardComponent,
    TagsComboboxModule,
    DatetimePickerComponent,
    ChipsSelectComponent,
    ItemsSelectorModule,
    TagsSelectComponent,
    UserInfoComponent,
    NodePathModule,
    GridModule,
    ToolbarModule,
    RmeBaseGridFilterComponent,
    Q9ContextMenuComponent
  ],
  providers: [ConfigGenerateService],
  declarations: [
    MetadataItemsComponent,
    FilterItemComponent,
    EditFilterFormComponent,
    SelectColumnsViewComponent,
    SelectMetadataViewComponent,
    AddFiltersViewComponent,
    FormatOperatorPipe,
    FormatValuePipe,
    SubtypeConverterPipe,
    MiniNodeSearchComponent,
    UserSearchComponent,
    CustomMetadataViewComponent
  ],
  exports: [
    SelectColumnsViewComponent,
    SelectMetadataViewComponent,
    AddFiltersViewComponent,
    MiniNodeSearchComponent,
    CustomMetadataViewComponent
  ]
})
export class CustomViewModalViewsModule {}
